import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { IoLanguage } from "react-icons/io5";
import { useIframeSettings } from "../_helpers/IframeSettingsContext";

// Language switcher: a language icon that opens a menu of allowedLanguages.
// Shows only when language switching is allowed; the selected code is highlighted.
// On select, updates shared context (no reload) so consumers re-render with the new dictionary.
const LANG_LABELS = { en: "English", hi: "हिंदी", it: "italiano", ge: "Deutsch", ch: "粵語", es: "español", HUF: "Magyar" };

export default function LanguageDropdown({ themeData, className = "" }) {
    const { languageCode, setLanguageCode } = useIframeSettings();
    const allow =
        themeData &&
        themeData.allowLanguageChange &&
        themeData.allowLanguageChange.toString() !== "0";

    const options =
        allow && themeData.allowedLanguages
            ? themeData.allowedLanguages.split(",").map((c) => c.trim()).filter(Boolean)
            : [];

    const [anchorEl, setAnchorEl] = useState(null);

    if (!allow || options.length === 0) return null;

    const lang = options.includes(languageCode) ? languageCode : options[0];

    const handleSelect = (code) => {
        setAnchorEl(null);
        setLanguageCode(code);
    };

    return (
        <div className={`iframe-language d-inline-flex align-items-center ${className}`}>
            <IconButton
                size="small"
                title="Change language"
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                <IoLanguage style={{ fontSize: 22 }} />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                PaperProps={{
                    style: {
                        maxHeight: 240,
                        backgroundColor: themeData?.nav_bar_color || "#fff",
                    },
                }}
            >
                {options.map((code) => (
                    <MenuItem
                        key={code}
                        selected={code === lang}
                        onClick={() => handleSelect(code)}
                    >
                        {LANG_LABELS[code] || code}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
